import { SkillDetail } from 'types/Section';

export const skillDetail: SkillDetail = {
  'HTML/CSS, JavaScript': [
    '웹 표준을 준수하며, 반응형 웹 디자인을 위한 @media 쿼리를 활용할 수 있습니다.',
    'ES6 문법을 사용하고 비동기 처리를 위한 Promise 및 async/await를 활용할 수 있습니다.',
    'DOM 조작 및 이벤트 처리에 대한 이해가 있으며 사용자 상호작용을 기반으로 기능을 구현할 수 있습니다.',
  ],
  TypeScript: [
    '기본 개념과 동작 원리를 이해하고 프로젝트에 적용할 수 있습니다.',
    '코드의 안전성과 명확성을 높이기 위해 타입 정의와 인터페이스를 활용할 수 있습니다.',
  ],
  React: [
    'React Hooks를 사용하여 상태 관리 및 사이드 이펙트를 처리할 수 있습니다.',
    '컴포넌트 기반 구조를 이해하고, 재사용 가능한 UI 구성 요소를 개발할 수 있습니다.',
  ],
  'Next.js': [
    '페이지 기반 라우팅 및 서버 사이드 렌더링의 개념을 이해하고, 프로젝트에 적용한 경험이 있습니다.',
    '메타 태그를 설정하여 SEO 개선의 기초적인 작업을 수행할 수 있습니다.',
  ],
};
